export interface TicketCategory {
  id: number;
  category_name: string;
  category_code: string;
  createdAt: string;
  updatedAt: string;
}

export interface TicketAttachment {
  id: string;
  fileName: string;
  fileSize: number;
  mimeType: string;
  created: string;
  url: string;
}

export interface TicketComment {
  id: string;
  author: string;
  body: string;
  created: string;
  updated: string;
}

export interface SupportTicket {
  jiraTicketId: string;
  summary: string;
  description: string;
  status: string;
  category: string;
  environment: string;
  pageRoute: string;
  reporterEmail?: string;
  attachments?: TicketAttachment[];
  comments?: TicketComment[];
  createdAt: string;
  updatedAt: string;
  jiraUrl: string;
}

export interface SupportTicketListItem {
  jiraTicketId: string;
  summary: string;
  description: string;
  status: string;
  category: string;
  environment: string;
  pageRoute: string;
  createdAt: string;
  updatedAt: string;
  jiraUrl: string;
}

export interface CreateTicketPayload {
  category_id: number;
  description: string;
  page_route: string;
  environment: string;
  attachments?: File[];
}

export interface CreateTicketResponse {
  ticket: {
    id: number;
    jiraTicketId: string;
    summary: string;
    description: string;
    status: string;
    category: string;
    pageRoute: string;
    environment: string;
    createdAt: string;
    jiraUrl: string;
  };
  attachments: Array<{
    filename: string;
    status: 'success' | 'failed';
    error?: string;
  }>;
  message: string;
}

// Chat-specific interfaces
export enum ChatStep {
  CLOSED = 'CLOSED',
  WELCOME = 'WELCOME',
  CATEGORY = 'CATEGORY',
  TITLE = 'TITLE',
  DESCRIPTION = 'DESCRIPTION',
  ATTACHMENTS = 'ATTACHMENTS',
  REVIEW = 'REVIEW',
  SUBMITTED = 'SUBMITTED'
}

export interface ChatMessage {
  id: string;
  type: 'bot' | 'user';
  content: string | React.ReactNode;
  timestamp: Date;
  metadata?: {
    step: ChatStep;
    isError?: boolean;
  };
}

export interface ChatFormData {
  selectedCategory: TicketCategory | null;
  title: string;
  description: string;
  attachments: File[];
}
